export const GET_LIVE_AUCTIONS = "get_live_auction";
export const GET_LIVE_AUCTION_SUCCESS = "get_live_auction_success";
export const GET_LIVE_AUCTION_FAIL = "get_live_auction_fail";
